import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';

export const EmptyList: FC = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'vfoImportDocument' });

  return (
    <Container>
      <Icon name="file-text" size="s44" />
      <Text size={14} bold>
        {t('emptyList')}
      </Text>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: ${COLORS.systemDark100};
`;

const Text = styled(Title)`
  &&& {
    color: ${COLORS.systemDark200};
  }
`;
